import { createAction, props } from '@ngrx/store';
import { TechStackDto } from 'src/portal/buyerscaddy-api/models/tech-stack-dto';

export const loadTechStack = createAction(
  '[TechStack] Load TechStack',
  props<{ id: string }>()
);

export const loadTechStackSuccess = createAction(
  '[TechStack] Load TechStack Success',
  props<{ techStack: any }>()
);

export const loadTechStackFailure = createAction(
  '[TechStack] Load TechStack Failure',
  props<{ error: any }>()
);

export const updateTechStack = createAction(
  '[TechStack] Update TechStack',
  props<{techStack: any }>()
);
